var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCez(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cez_svg__clip0_224_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0v60h60V0z",
    fill: "#F24F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.412 48.706h37.294v-7.53H18.824V18.823h29.882v-7.411H11.412v37.294z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.352 26.235h22v7.412h-22v-7.412z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cez_svg__clip0_224_46"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgCez;